import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import isString from "@frog/source/utility/isString.js"

export default function convertOldOverworldScripting(oldevents) {
    let steps = []

    oldevents.forEach((oldevent) => {
        if(oldevent.type == "Wait") {
            // steps.push(PlotSteps.Wait(oldevent.time * 1000))
        } else if(oldevent.type == "TransitionScreen") {
            steps.push({"func": () => Navigation.go(oldevent.screen)})
        } else if(oldevent.type == "UnlockLocations") {
            steps.push({
                "func": () => {
                    oldevent.locationKeys.forEach((locationKey) => {
                        App.game.overworld.locations[locationKey].isReachable = true
                        App.game.overworld.locations[locationKey].isDisplayed = true
                    })
                    oldevent.routeKeys.forEach((routeKey) => {
                        App.game.overworld.routes[routeKey].isReachable = true
                        App.game.overworld.routes[routeKey].isDisplayed = true
                    })
                }
            })
            // steps.push(PlotSteps.Wait(1.25 * 1000))
            // steps.push({
            //     "func": () => {
            //         oldevent.routeKeys.forEach((routeKey) => {
            //             App.game.overworld.routes[routeKey].isReachable = true
            //             App.game.overworld.routes[routeKey].isDisplayed = true
            //         })
            //     }
            // })
        } else if(oldevent.type == "DisplayEventualRoute") {
            steps.push({
                "func": () => {
                    oldevent.routeKeys.forEach((routeKey) => {
                        App.game.overworld.routes[routeKey].isDisplayed = true
                    })
                }
            })
            // steps.push(PlotSteps.Wait(1 * 1000))
        } else if(oldevent.type == "DisplayLocations") {
            steps.push({
                "func": () => {
                    oldevent.locationKeys.forEach((locationKey) => {
                        App.game.overworld.locations[locationKey].isDisplayed = true
                    })
                }
            })
            // steps.push(PlotSteps.Wait(0.5 * 1000))
        } else if(oldevent.type == "FinishLocation") {
            steps.push({
                "func": () => {
                    App.game.overworld.locations[oldevent.locationKey].isFinished = true
                }
            })
        }
    })

    return steps
}
